import { render, staticRenderFns } from "./DatenschutzCockpit.vue?vue&type=template&id=c303bc10"
import script from "./DatenschutzCockpit.vue?vue&type=script&lang=js"
export * from "./DatenschutzCockpit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports